import { ScaledImage as ScaledImageImpl, CDNImageContext, IMAGE_CDN_ROOT } from "lib-core"
import { selectInstanceName } from "profile/profile.selectors"
import React from "react"
import { useSelector } from "react-redux"
import { ReactFC } from "types"

export const ScaledImage = ScaledImageImpl

export const CDNImageContextProvider: ReactFC = ({ children }) => {
  const instanceName = useSelector(selectInstanceName)

  return (
    <CDNImageContext.Provider value={{
      cdnRoot: IMAGE_CDN_ROOT,
      instanceName,
      baseUrl(instanceNameOverride?: string) {
        return `${IMAGE_CDN_ROOT}${instanceNameOverride || instanceName}`
      }
    }}>
      {children}
    </CDNImageContext.Provider>
  )
}

export default ScaledImage
